/**
 * A selector which returns the locally configured name to use for the Spot-TV
 * to be displayed while in a meeting.
 *
 * @param {Object} state - The Redux state.
 * @returns {boolean}
 */
export function getDisplayName(state) {
    return state.setup.displayName;
}

/**
 * Returns the JWT for authentication with backend services.
 *
 * @param {Object} state - The Redux state.
 * @returns {string}
 */
export function getJwt(state) {
    return state.setup.jwt;
}

/**
 * A selector which returns the label for the camera device that should be
 * attempted to be used when starting a call.
 *
 * @param {Object} state - The Redux state.
 * @returns {string}
 */
export function getPreferredCamera(state) {
    return state.setup.preferredCamera;
}

/**
 * A selector which returns the resolution that should be
 * used to compute video constraints.
 *
 * @param {Object} state - The Redux state.
 * @returns {string}
 */
export function getPreferredResolution(state) {
    return state.setup.preferredResolution;
}

/**
 * A selector which returns the label for the microphone device that should be
 * attempted to be used when starting a call.
 *
 * @param {Object} state - The Redux state.
 * @returns {string}
 */
export function getPreferredMic(state) {
    return state.setup.preferredMic;
}

/**
 * A selector which returns the label for the speaker device that should be
 * attempted to be used when starting a call.
 *
 * @param {Object} state - The Redux state.
 * @returns {string}
 */
export function getPreferredSpeaker(state) {
    return state.setup.preferredSpeaker;
}

/**
 * Returns the params the app was started with.
 *
 * @param {Object} state - The Redux state.
 * @returns {Object}
 */
export function getStartParams(state) {
    return state.setup.startParams || {};
}

/**
 * Returns the tenant name stored in the Redux state.
 *
 * @param {Object} state - The Redux store.
 * @returns {?string}
 */
export function getTenant(state) {
    return state.setup.tenant;
}

/**
 * Returns whether or not any permanent Spot Remote is currently connected.
 *
 * @param {Object} state - The Redux store.
 * @returns {boolean}
 */
export function isPermanentRemotePaired(state) {
    return state.setup.isPermanentRemotePaired;
}

/**
 * A selector which returns whether or not the application has been configured.
 *
 * @param {Object} state - The Redux state.
 * @returns {boolean}
 */
export function isSetupComplete(state) {
    return state.setup.completed;
}

/**
* A selector which returns whether or not the current client is a Spot
* instance.
*
* @param {Object} state - The Redux state.
* @returns {boolean}
*/
export function isSpot(state) {
    return state.setup.isSpot;
}
